module.exports = __webpack_public_path__ + "img/29_46.bc230f6b.png";